import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagFrontLineWorkersProps {}

const ColorTagFrontLineWorkers: React.FC<ColorTagFrontLineWorkersProps> = props => {
  return <ColorTag className="ColorTagFrontLineWorkers" color="aqua">Front Line Workers</ColorTag>
}

export default ColorTagFrontLineWorkers;